export default __webpack_public_path__ + "static/media/easybar_screen_half.1931f89a.png";